import React  from 'react';
import PropTypes from 'prop-types';
// import { preventNonNumericalInput } from '../../../utils/commonUtils';
// import {setAndGetAttributes} from './FormInputFunctions';

const NewNumberInput = (props)=>{
  // Props Attr
   const {
    className,
    placeholder,
    value,
    style,
    name,
    required,
    disabled,
    readOnly,
    Max, // Changed to match your JSON prop name
    decimalAllowed,
    onKeyPress,
    label,
    changeHandler // Destructured here for consistency
  } = props;

  const onChangeHandler = (e) => {
    let val = e.target.value;

    // 1. Remove non-numeric characters based on decimalAllowed
    if (decimalAllowed) {
      val = decimalValidation(val);
    } else {
      val = val.replace(/\D/g, ''); 
    }

    // 2. Apply the Digit Limit (Length restriction)
    // If Max is passed (e.g., 4), we slice the string to that length
    if (Max) {
      const maxLength = parseInt(Max);
      if (val.length > maxLength) {
        val = val.slice(0, maxLength);
      }
    }

    changeHandler(val, { e });
  }
  const decimalValidation=(val)=>{
    val = val.replace(/[^\d.]/g, '');
    if ((val.match(/\./g) || []).length > 1) {// Ensure there is only one decimal point
      val = val.replace(/\.+$/, "");
    }
    const parts = val.split('.'); // Ensure at most two decimal places
    if (parts.length > 1) {
      parts[1] = parts[1].slice(0, 2); // Limit to two decimal places
    }
    val = parts.join('.');
    return val;
  };

  return (
    <div className="form-group mb-0">
      {label && <label className="form-label">{label}</label>}
      <input
        className={className}
        name={name}
        id={name}
        type="text"
        placeholder={placeholder}
        value={value}
        style={{ ...style }}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        onKeyDown={onKeyPress}
        onChange={onChangeHandler} 
      />
    </div>
  );
};

NewNumberInput.defaultProps = {
  className: 'form-control',
  placeholder: '',
  required: false,
  readOnly: false,
  disabled: false,
  onKeyPress: () => {},
  value: '',
  style: {},
  decimalAllowed: false,
  Max: null, // Default to null so it doesn't restrict unless specified
};

NewNumberInput.propTypes = {
  Max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  required: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.object,
  changeHandler: PropTypes.func.isRequired,
  label: PropTypes.string,
};

export default NewNumberInput;